export default "__VITE_ASSET__3e41d26c__"